import { useAuth } from '../auth/AuthenticationContext.jsx';
import AppMenu from '../navigation/AppMenu.jsx';
import Bone from '../components/Skeleton.jsx';

// The Property screen while its data is still on its way — the shape the app
// shows for the same moment (Property.js isLoading): the real header, then bones
// where the property name, the zone tiles and the action rows will land. It
// replaces the plain "Checking your account…" / "Loading…" text that used to hold
// the screen for a second or two after sign-in.
//
// The bones reuse the real layout classes (.zone-tile-row, .property-action-row,
// .action-panel) so they sit exactly where the content will, at every width —
// including the single-row tile shape a wide slot switches to.

// Just the body, for the Property screen itself, which already renders its header.
export function PropertySkeletonBody() {
  return (
    <div aria-hidden="true">
      <Bone className="skeleton--heading" />
      <ul className="zone-tile-row">
        <li className="zone-tile-row__item">
          <Bone className="skeleton-tile" />
        </li>
        <li className="zone-tile-row__item">
          <Bone className="skeleton-tile" />
        </li>
      </ul>
      <div className="property-action-row">
        {[0, 1].map((row) => (
          <span key={row} className="action-panel">
            <Bone className="action-panel__icon" />
            <span className="action-panel__text">
              <Bone className="skeleton--line skeleton--title" />
              <Bone className="skeleton--line" />
            </span>
          </span>
        ))}
      </div>
    </div>
  );
}

// The whole screen: header (menu button + greeting, both real — the user is known
// by now) plus the body. `message` is what assistive tech is told is happening.
export default function PropertySkeleton({ message }) {
  const { user } = useAuth();
  const firstName = user?.given_name;
  return (
    <main className="app-shell dashboard">
      <header className="app-header">
        <AppMenu />
        <div className="greeting">
          <h1 className="greeting__title">
            Hello
            {firstName ? (
              <>
                , <span className="greeting__name">{firstName}</span>
              </>
            ) : null}
          </h1>
          <p className="greeting__subtitle">Welcome to your heating portal</p>
        </div>
      </header>
      <p role="status" aria-busy="true" className="visually-hidden">
        {message}
      </p>
      <PropertySkeletonBody />
    </main>
  );
}
